import { createApi } from '@reduxjs/toolkit/query/react';

import { Feature, FeatureGroup } from '@/slices/features/feature.types';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

type ConfigureFeatureInput = {
  feature: string;
  strategy: 'on_off' | 'whitelist';
  enabled: boolean;
  targetId?: string;
};

const featureApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api',
  }),
  reducerPath: 'feature',
  tagTypes: ['Feature'],
  endpoints: (build) => ({
    getFeatures: build.query<
      Feature[],
      {
        group: FeatureGroup;
        targetId?: string;
      }
    >({
      query: ({ group, targetId }) => ({
        url: targetId
          ? `/admin/features/${group}/${targetId}`
          : `/admin/features/${group}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { targetId }) => [
        { type: 'Feature', id: `${targetId ?? 'global'}` },
      ],
    }),
    getEnabledFeatures: build.query<Feature[], void>({
      query: () => ({
        url: '/features/enabled',
        method: 'GET',
      }),
      providesTags: () => [{ type: 'Feature', id: 'currentUser' }],
    }),
    configureFeature: build.mutation<void, ConfigureFeatureInput>({
      query: ({ feature, ...body }) => ({
        url: `/admin/features/${feature}`,
        method: 'PATCH',
        data: body,
      }),
      invalidatesTags: (_result, _error, { targetId }) => [
        {
          type: 'Feature',
          id: `${targetId ?? 'global'}`,
        },
        {
          type: 'Feature',
          id: 'currentUser',
        },
      ],
    }),
  }),
});

export default featureApi;
